(($) => {

	let $iframes;

	window.addEventListener('load', init);

	function init() {
		$iframes = $('iframe#iFrameProviderSearch');

		if ($iframes.length == 0) {
			return false;
		}

		$iframes.each(initIframe);
	}

	function initIframe(iframeIndex, iframeElement) {
		if (!iframeElement) {
			return false;
		}

        let $iframe = $(iframeElement);

        bind();

        function bind() {
		    window.addEventListener('message', onWindowMessage, false);
        }

		function onWindowMessage(event) {
            if (!event instanceof MessageEvent) {
                return false;
            }

			var data = (typeof event.data == 'string') ? JSON.parse(event.data) : event.data;

			if (data['docHeight']) { 
                setHeight(data['docHeight']); 
            }

			if (data['scrollTop']) { 
                setScroll(data['scrollTop']); 
            }
		}

		function setHeight(docHeight) { 
			$iframe.height(docHeight);
        }

		function setScroll(top) {
			setTimeout(function() {
                window.scroll({ top: $iframe.get(0).offsetTop + top, left: 0, behavior: 'smooth' }); 
            }, 500); 
        }
	}
})(jQuery);